export default __webpack_public_path__ + "static/media/rating_2.177615fe.png";